import {
  OPEN_PLATFORM_APP_LEARN_MORE_PAGE_REQUEST,
  OPEN_PLATFORM_APP_LEARN_MORE_SET_APP,
  OPEN_PLATFORM_APP_LEARN_MORE_ON_CHANGE_FIELD,
  OPEN_PLATFORM_APP_LEARN_MORE_RESET,
} from './constants';

export function pageRequest({ id, version }) {
  return {
    type: OPEN_PLATFORM_APP_LEARN_MORE_PAGE_REQUEST,
    payload: { id, version },
  };
}

export function setApp({ app }) {
  return {
    type: OPEN_PLATFORM_APP_LEARN_MORE_SET_APP,
    payload: { app },
  };
}

export function onChangeField({ field, value, searchValues }) {
  return {
    type: OPEN_PLATFORM_APP_LEARN_MORE_ON_CHANGE_FIELD,
    payload: { field, value, searchValues },
  };
}

export function reset() {
  return { type: OPEN_PLATFORM_APP_LEARN_MORE_RESET, payload: {} };
}
